import { Code, Smartphone, Megaphone, Mail, MessageCircle, Cpu } from "lucide-react";
const our_services = [
  {
    title: "Web Development",
    desc: "Modern, fast and scalable web applications.",
    icon: <Code size={24} />,
  },
 
  {
    title: "App Development",
    desc: "Custom Android and iOS applications built for performance, scalability, and seamless user experience.",
    icon: <Smartphone size={24} />,
  },
  {
    title: "AI Automation",
    desc: "Streamline your business processes with smart AI-powered automation solutions.",
    icon: <Cpu size={24} />,
  },
  {
    title: "Email Marketing",
    desc: "Reach your audience directly with targeted and high-converting email campaigns.",
    icon: <Mail size={24} />,
  },
    {
      title: "Social Media Marketing",
      desc: "Grow your audience with powerful campaigns.",
      icon: <Megaphone size={24} />,
    },
  
    {
      title: "WhatsApp Marketing",
      desc: "Engage customers instantly with personalized WhatsApp campaigns and automation.",
      icon: <MessageCircle size={24} />,
    }
    
    
  ];

  export default our_services;